import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Form, SelectPicker, Input, DatePicker } from 'rsuite'
import ButtonPanelWidget from '../ButtonPanelWidget'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import { doneLoading, startLoading } from '../../utils/loading'
import { getLawStatus, getLawSubStatus } from '../../redux/actions/legal'
import { cloneDeep } from 'lodash-es'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'

export default function SearchLegalManagement(props) {
  const {
    onSubmitData = () => {},
    onCancelData = () => {},
    register,
    errors,
    error,
    Controller,
    control,
    setValue,
    getValues,
    clearErrors,
  } = props

  const lawStatusOptions = props.schema?.lawStatus?.options || []
  const lawSubStatusOptions = props.schema?.lawSubStatus?.options || []

  const [isError, setIsError] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  const handlerOnSave = (data) => {
    // console.log('handlerOnSave ', data)
    onSubmitData(data)
  }

  const handlerOnCancel = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }
    onCancelData()
  }

  const onChangeLawStatus = async (value) => {
    setValue(formSchema.lawSubStatus.name, '')
    if (value) {
      await getLawSubStatusOptions(value)
    }
  }

  const onChangeLawType = async (value) => {
    setValue(formSchema.lawStatus.name, '')
    setValue(formSchema.lawSubStatus.name, '')
    if (value) {
      await getLawStatusOptions(value)
    } else {
      var sh = cloneDeep(formSchema)
      sh.lawStatus.value = ''
      sh.lawStatus.options = lawStatusOptions
      sh.lawSubStatus.value = ''
      sh.lawSubStatus.options = lawSubStatusOptions
      setFormSchema(sh)
    }
  }

  const getLawStatusOptions = async (lawtype) => {
    startLoading()
    try {
      var options
      if (lawtype) {
        const response = await getLawStatus(lawtype)
        options = response?.results || []
      } else {
        options = lawStatusOptions
      }

      var sh = cloneDeep(formSchema)
      sh.lawStatus.value = ''
      sh.lawStatus.options = options

      setFormSchema(sh)
    } catch (e) {}
    doneLoading()
  }

  const getLawSubStatusOptions = async (lawtype, lawStatus) => {
    startLoading()
    try {
      var options
      if (lawStatus) {
        const response = await getLawSubStatus(lawtype, lawStatus)
        options = response?.results || []
      } else {
        options = lawSubStatusOptions
      }

      var sh = cloneDeep(formSchema)
      sh.lawSubStatus.value = ''
      sh.lawSubStatus.options = options

      setFormSchema(sh)
    } catch (e) {}
    doneLoading()
  }

  return (
    <>
      <Panel collapsible defaultExpanded>
        <Form>
          <Row>
            {formSchema?.lawType && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={8}
                  xs={8}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.lawType.validators, formSchema.lawType.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <ErrorMessage
                    error={errors[formSchema.lawType.name]}
                    style={{ marginBottom: 10 }}
                  />
                  <Controller
                    name={formSchema.lawType.name}
                    control={control}
                    defaultValue={formSchema.lawType.value}
                    rules={isValidators(formSchema.lawType.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={formSchema.lawType.options}
                          searchable={true}
                          disabled={formSchema.lawType.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.lawType.hint || `เลือก${formSchema.lawType.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            onChangeLawType(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}

            {formSchema?.department && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={8}
                  xs={8}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.department.validators, formSchema.department.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <ErrorMessage
                    error={errors[formSchema.lawType.name]}
                    style={{ marginBottom: 10 }}
                  />
                  <Controller
                    name={formSchema.department.name}
                    control={control}
                    defaultValue={formSchema.department.value}
                    rules={isValidators(formSchema.department.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={formSchema.department.options}
                          searchable={true}
                          disabled={formSchema.department.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.department.hint || `เลือก${formSchema.department.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}

            {formSchema?.projectCode && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={8}
                  xs={8}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.projectCode.validators, formSchema.projectCode.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <Input
                    placeholder={formSchema.projectCode.hint}
                    // defaultValue={formSchema.projectCode.value}
                    name={formSchema.projectCode.name}
                    inputRef={register(isValidators(formSchema.projectCode.validators))}
                  />
                </Col>
              </>
            )}

            {formSchema?.projectName && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={8}
                  xs={8}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.projectName.validators, formSchema.projectName.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <Input
                    placeholder={formSchema.projectName.hint}
                    // defaultValue={formSchema.projectCode.value}
                    name={formSchema.projectName.name}
                    inputRef={register(isValidators(formSchema.projectName.validators))}
                  />
                </Col>
              </>
            )}

            {formSchema?.docNumberOfPurchase && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={8}
                  xs={8}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(
                    formSchema.docNumberOfPurchase.validators,
                    formSchema.docNumberOfPurchase.label
                  )}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <Input
                    placeholder={formSchema.docNumberOfPurchase.hint}
                    defaultValue={formSchema.docNumberOfPurchase.value}
                    name={formSchema.docNumberOfPurchase.name}
                    inputRef={register()}
                  />
                </Col>
              </>
            )}

            {formSchema?.contractNumberRef && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={8}
                  xs={8}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(
                    formSchema.contractNumberRef.validators,
                    formSchema.contractNumberRef.label
                  )}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <Input
                    placeholder={formSchema.contractNumberRef.hint}
                    defaultValue={formSchema.contractNumberRef.value}
                    name={formSchema.contractNumberRef.name}
                    inputRef={register()}
                  />
                </Col>
              </>
            )}
          </Row>

          <Row>
            {formSchema?.lawStatus && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.lawStatus.validators, formSchema.lawStatus.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <ErrorMessage
                    error={errors[formSchema.lawStatus.name]}
                    style={{ marginBottom: 10 }}
                  />
                  <Controller
                    name={formSchema.lawStatus.name}
                    control={control}
                    defaultValue={formSchema.lawStatus.value}
                    rules={isValidators(formSchema.lawStatus.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={formSchema.lawStatus.options}
                          searchable={true}
                          disabled={formSchema.lawStatus.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.lawStatus.hint || `เลือก${formSchema.lawStatus.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            onChangeLawStatus(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}

            {formSchema?.capital && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={8}
                  xs={8}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.capital.validators, formSchema.capital.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <Input
                    placeholder={formSchema.capital.hint}
                    type="number"
                    // defaultValue={formSchema.projectCode.value}
                    name={formSchema.capital.name}
                    inputRef={register(isValidators(formSchema.capital.validators))}
                  />
                </Col>
              </>
            )}
          </Row>

          <Row>
            {formSchema?.startDueDate && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.startDueDate.validators, formSchema.startDueDate.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <ErrorMessage
                    error={errors[formSchema.startDueDate.name]}
                    style={{ marginBottom: 10 }}
                  />
                  <Controller
                    name={formSchema.startDueDate.name}
                    control={control}
                    defaultValue={formSchema.startDueDate.value}
                    rules={isValidators(formSchema.startDueDate.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format="DD/MM/YYYY"
                          locale={LOCAL_DAY_TH}
                          data={formSchema.startDueDate.options}
                          searchable={true}
                          disabled={formSchema.startDueDate.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.startDueDate.hint || `เลือก${formSchema.startDueDate.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            onChangeLawStatus(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}
            {formSchema?.endDueDate && (
              <>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                    textAlign: 'right',
                  }}
                >
                  {requiredFiled(formSchema.endDueDate.validators, formSchema.endDueDate.label)}
                </Col>
                <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                  <ErrorMessage
                    error={errors[formSchema.endDueDate.name]}
                    style={{ marginBottom: 10 }}
                  />
                  <Controller
                    name={formSchema.endDueDate.name}
                    control={control}
                    defaultValue={formSchema.endDueDate.value}
                    rules={isValidators(formSchema.endDueDate.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format="DD/MM/YYYY"
                          locale={LOCAL_DAY_TH}
                          data={formSchema.endDueDate.options}
                          searchable={true}
                          disabled={formSchema.endDueDate.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.endDueDate.hint || `เลือก${formSchema.endDueDate.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            onChangeLawStatus(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}
          </Row>
        </Form>

        <hr />

        <ButtonPanelWidget
          isEdit={true}
          isError={isError}
          buttonText={formSchema.buttonText}
          onSave={handlerOnSave}
          onCancel={handlerOnCancel}
        />
      </Panel>
    </>
  )
}
